export enum CarouselDrawerContentActionsEnum {
  SET_DRAWER_CONTENT = '@carouselDrawerContent/SET_DRAWER_CONTENT',
}
